module.exports = __webpack_public_path__ + "img/accounts1.80da8402.jpg";